import { useState } from 'react';
import { Navigate } from 'react-router-dom';

import OnboardingFlow from '@/components/OnboardingPage/OnboardingFlow';
import useAuth from '@/hooks/useAuth';

function OnboardingPage() {
  const { user, orgID } = useAuth();
  const [isFinalizing, setIsFinalizing] = useState(false);

  // Only redirect pre-existing logged-in users away from onboarding.
  // Do NOT redirect while finalization is in progress: OnboardingStepThree
  // signs the user in then runs async upload → claim → navigate. Redirecting
  // here as soon as `user` and `orgID` are set would abort that work.
  if (user && orgID && !isFinalizing) {
    return <Navigate to="/" replace />;
  }

  return <OnboardingFlow onFinalizingChange={setIsFinalizing} />;
}

export default OnboardingPage;
